class GoogleDistanceMatrixAdaptor implements IDistanceService {
  service: google.maps.DistanceMatrixService

  constructor(service: google.maps.DistanceMatrixService) {
    this.service = service
  }

  private static createRequest(
    origin: google.maps.LatLngLiteral | string,
    destinations: string[] | google.maps.LatLngLiteral[],
    travelMode: google.maps.TravelMode,
  ): google.maps.DistanceMatrixRequest {
    return {
      destinations,
      origins: [origin],
      unitSystem: 1.0 as google.maps.UnitSystem.IMPERIAL,
      travelMode,
    }
  }

  private static convertToTransportationInformation(
    walkResult: google.maps.DistanceMatrixResponse,
    driveResult: google.maps.DistanceMatrixResponse,
    destinationsName: string[],
  ): TransportationInformation[] {
    const result: TransportationInformation[] = []
    destinationsName.forEach((destination, index) => {
      const walkTime = walkResult.rows[0]?.elements[index] || {}
      const driveTime = driveResult.rows[0]?.elements[index] || {}
      result.push({
        location: destination,
        driveTime: driveTime?.duration?.value,
        walkTime: walkTime?.duration?.value,
        distance: {
          unit: 'MILE',
          value: driveTime?.distance
            ? driveTime.distance.value * 0.000621371
            : driveTime?.distance?.value,
        },
      })
    })
    return result
  }

  async get(
    origin: google.maps.LatLngLiteral | string,
    destinationsName: string[],
    destinations: string[] | google.maps.LatLngLiteral[],
  ): Promise<TransportationInformation[]> {
    if (!this.service) {
      throw new Error('Service is undefined')
    }
    const walkRequest = GoogleDistanceMatrixAdaptor.createRequest(
      origin,
      destinations,
      'WALKING' as google.maps.TravelMode.WALKING,
    )
    const driveRequest = GoogleDistanceMatrixAdaptor.createRequest(
      origin,
      destinations,
      'DRIVING' as google.maps.TravelMode.DRIVING,
    )
    try {
      const [walkResult, driveResult] = await Promise.all([
        this.service.getDistanceMatrix(walkRequest),
        this.service.getDistanceMatrix(driveRequest),
      ])
      return GoogleDistanceMatrixAdaptor.convertToTransportationInformation(
        walkResult,
        driveResult,
        destinationsName,
      )
    } catch (e) {
      return []
    }
  }
}

export default GoogleDistanceMatrixAdaptor
